import { ref, onMounted } from "vue"

export function useIosDevice() {
  const isIOS = ref(false)

  onMounted(() => {
    const ua = navigator.userAgent
    isIOS.value = /iPad|iPhone|iPod/.test(ua) && !(window as any).MSStream
  })

  return { isIOS }
}